import { ReactElement } from 'react';

import { Box, List } from '@mui/material';
import { useSelector } from 'react-redux';

import Popper from '@/components/Popper';

import DataHubDropdownItem from './DataHubDropdownItem';
import { RootState } from '../../../store';

const DataHubsDropdown = ({
  buttonContent,
  buttonVariant,
  disabled
}: {
  buttonContent: ReactElement;
  buttonVariant?: 'text' | 'outlined' | 'contained';
  disabled: boolean;
}) => {
  const { dataHubs } = useSelector((state: RootState) => state.dataHub);

  return (
    <Popper
      buttonContent={buttonContent}
      buttonVariant={buttonVariant}
      disabled={!dataHubs?.length || disabled}
      placement='bottom-start'
    >
      <Box
        sx={{
          width: 192,
          borderBottom: '1px solid',
          borderLeft: '1px solid',
          borderColor: 'primary.main',
          display: 'flex',
          flexDirection: 'column',
          fontSize: '14px',
          maxHeight: 424,
          overflowY: 'auto'
        }}
      >
        <List disablePadding>
          {[...dataHubs]
            .sort((a, b) => new Date(b.savedAt).getTime() - new Date(a.savedAt).getTime())
            .map(dataHub => (
              <DataHubDropdownItem
                key={dataHub.id}
                dataHub={dataHub}
              />
            ))}
        </List>
      </Box>
    </Popper>
  );
};

export default DataHubsDropdown;
